import { Box, Button, Drawer } from '@mui/material';
import React, { useEffect, useState } from 'react';
import DateSelect from '../shared/DateSelect';
import LocationSelect from '../shared/LocationSelect';
import { useNavigate, useParams } from 'react-router-dom';
import { getTherapistAvailability } from '../../../../helper/api.helper';
import toast from 'react-hot-toast';
import TimeslotSelect from '../shared/TimeslotSelect';
import SessionSelect from '../shared/SessionSelect';

const getMaximumBookingDays = (locations, selectedLocation) => {
  const maximumBookingDays = Number(
    locations.find((location) => location.id === selectedLocation)?.maximumBookingDays
  );
  return Number.isFinite(maximumBookingDays) && maximumBookingDays > 0 ? maximumBookingDays : 30;
};

const isAfterMaximumBookingWindow = (date, maximumBookingDays) => {
  const selectedDay = new Date(date);
  selectedDay.setHours(0, 0, 0, 0);

  const lastBookableDay = new Date();
  lastBookableDay.setHours(0, 0, 0, 0);
  lastBookableDay.setDate(lastBookableDay.getDate() + maximumBookingDays);

  return selectedDay > lastBookableDay;
};

const getMaximumBookingWindowMessage = (maximumBookingDays) =>
  `You can book this session only up to ${maximumBookingDays} days from today. Please choose an earlier date.`;

const MobileViewPopup = ({
  isDrawerOpen,
  toggleDrawer,
  selectedEventType,
  handleEventTypeChange,
  selectedLocation,
  handleLocationChange,
  therapist,
  selectedDate,
  handleDateClick,
  selectedTimeIndex,
  handleTimeClick,
  services,
  locations,
  selectedTime
}) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [timeSlots, setTimeSlots] = useState([]);
  const maximumBookingDays = getMaximumBookingDays(locations, selectedLocation);
  const unavailableMessage = isAfterMaximumBookingWindow(selectedDate, maximumBookingDays)
    ? getMaximumBookingWindowMessage(maximumBookingDays)
    : '';

  useEffect(() => {
    if (id && selectedDate && selectedEventType && selectedLocation) {
      if (isAfterMaximumBookingWindow(selectedDate, maximumBookingDays)) {
        setTimeSlots([]);
        return;
      }
      getTherapistAvailability(id, {
        serviceId: selectedEventType,
        locationId: selectedLocation,
        selectedDate: selectedDate.getTime(),
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
      })
        .then((res) => res.json())
        .then((res) => {
          if (res.status === 'success') {
            setTimeSlots(res.data.slots);
          } else {
            toast.error(res.message);
          }
        })
        .catch((err) => {
          toast.error(err.message);
        });
    }
  }, [id, selectedDate, selectedEventType, selectedLocation, maximumBookingDays]);
  const navigateToCheckout = () => {
    const timestamp = new Date(selectedDate).getTime();
    navigate(
      `/therapists/${id}/checkout?date=${timestamp}&eventType=${selectedEventType}&location=${selectedLocation}&time=${encodeURIComponent(JSON.stringify(selectedTime))}`
    );
  };
  return (
    <>
      <Drawer
        anchor="bottom"
        open={isDrawerOpen}
        onClose={toggleDrawer(false)}
        PaperProps={{
          sx: {
            top: '10%',
            // borderRadius: '15px',
            padding: '0px 10px 20px 10px'
          }
        }}>
        <Box>
          <SessionSelect
            selectedEventType={selectedEventType}
            handleEventTypeChange={handleEventTypeChange}
            services={services}
          />

          <LocationSelect
            selectedEventType={selectedEventType}
            selectedLocation={selectedLocation}
            handleLocationChange={handleLocationChange}
            therapist={therapist}
            locations={locations}
            services={services}
          />

          <DateSelect
            selectedDate={selectedDate}
            handleDateClick={handleDateClick}
            maximumBookingDays={maximumBookingDays}
          />
          <TimeslotSelect
            timeSlots={timeSlots}
            selectedTimeIndex={selectedTimeIndex}
            handleTimeClick={handleTimeClick}
            unavailableMessage={unavailableMessage}
          />
          <div
            className="flex-container justify-center margin-top--md"
            style={{ maxWidth: '350px' }}>
            <Button
              disabled={
                !selectedDate ||
                !selectedEventType ||
                !selectedLocation ||
                !!unavailableMessage ||
                !selectedTime
              }
              variant="contained"
              color="primary"
              size="small"
              fullWidth
              onClick={navigateToCheckout}
              sx={{ textTransform: 'none' }}>
              Proceed to checkout
            </Button>
          </div>
        </Box>
      </Drawer>
      <style jsx>
        {`
          p,
          h3,
          h4,
          .main-div > span,
          div {
            color: black;
          }
          li {
            text-align: center;
            padding: 5px 5px;
            cursor: pointer;
            border-radius: 3px;
            border: 1px solid #097eff;
            color: #097eff;
            margin-bottom: 10px;
            font-weight: 600;
            font-size: 12px;
            width: 120px;
          }
          li:hover {
            outline: white;
            color: white;
            background-color: #097eff;
          }
          .selected {
            background-color: #097eff;
            color: white;
          }
          .list-items {
            overflow: scroll;
            max-width: 350px;
            height: 300px;
            flex-wrap: wrap;
          }
          @media only screen and (max-width: 350px) {
            li {
              padding: 10px 10px;
            }
          }
        `}
      </style>
    </>
  );
};

export default MobileViewPopup;
